var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVaccine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#163B6C",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 243.245 243.245",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "222.739,82.023 243.245,61.519 181.727,0 161.221,20.506 174.656,33.941 159.806,48.791 132.936,21.921 112.43,42.427 125.158,55.154 108.894,71.418 132.936,95.459 122.33,106.065 98.289,82.024 82.732,97.581 106.773,121.622 96.167,132.229 72.125,108.187 55.862,124.451 79.903,148.492 69.296,159.099 45.255,135.057 29.281,151.031 44.676,183.72 0,228.396 14.849,243.245 59.526,198.569 92.213,213.964 188.091,118.087 200.819,130.814 221.325,110.309 195.161,84.146 210.011,69.296 "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaccine);
export default __webpack_public_path__ + "static/media/vaccine.b9fddcb8d40c2071e1a5cba802da5e4d.svg";
export { ForwardRef as ReactComponent };